
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import StudentsHeroSection from './components/StudentsHeroSection';
import WelcomeSection from './components/WelcomeSection';
import MembershipBenefitsSection from './components/MembershipBenefitsSection';
import ResourcesSection from './components/ResourcesSection';
import ScholarshipsSection from './components/ScholarshipsSection';
import EventsSection from './components/EventsSection';
import GetInvolvedSection from './components/GetInvolvedSection';
import StudentCouncilSection from './components/StudentCouncilSection';
import StudentsCTASection from './components/StudentsCTASection';

export default function Students() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <StudentsHeroSection />
      <WelcomeSection />
      <MembershipBenefitsSection />
      <ResourcesSection />
      <ScholarshipsSection />
      <EventsSection />
      <GetInvolvedSection />
      <StudentCouncilSection />
      <StudentsCTASection />
      <Footer />
    </div>
  );
}
